// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateElementLayoutReducer extends Reducer
{
	public static reducerName: string = "UpdateElementLayout";
	public static call(_elementId: number, _layoutId: number) {
		this.getReducer().call(_elementId, _layoutId);
	}

	public call(_elementId: number, _layoutId: number) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _layoutIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_layoutIdType, _layoutId);
		this.client.call("UpdateElementLayout", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let layoutIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let layoutIdValue = AlgebraicValue.deserialize(layoutIdType, adapter.next())
		let layoutId = layoutIdValue.asNumber();
		return [elementId, layoutId];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _layoutId: number) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _layoutId: number) => void)
	{
		this.client.on("reducer:UpdateElementLayout", callback);
	}
}


export default UpdateElementLayoutReducer
